var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrivalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25398 8.47001L7.88398 0.0880127L9.81699 0.606013L12.627 9.64101L17.888 11.051C18.0783 11.102 18.2567 11.1899 18.413 11.3098C18.5693 11.4297 18.7004 11.5792 18.7989 11.7498C18.8975 11.9204 18.9614 12.1087 18.9872 12.304C19.0129 12.4993 18.9999 12.6977 18.949 12.888C18.898 13.0783 18.8101 13.2567 18.6902 13.413C18.5703 13.5693 18.4208 13.7004 18.2502 13.799C18.0796 13.8975 17.8913 13.9615 17.696 13.9872C17.5007 14.0129 17.3023 14 17.112 13.949L2.13998 9.93701L2.91598 7.03901L3.15798 7.10401L4.07198 10.454L1.44498 9.75101C1.22972 9.69309 1.03998 9.56489 0.905908 9.38679C0.771836 9.20869 0.701117 8.9909 0.704985 8.76801L0.794985 3.36501L2.24398 3.75301L3.15798 7.10401L8.25398 8.47001ZM1.99998 17H18V19H1.99998V17Z",
    fill: "#5F6B7A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalIcon);
export default __webpack_public_path__ + "static/media/arrival-icon.98fa39d22b584032d87e1e85894a05ae.svg";
export { ForwardRef as ReactComponent };